document.addEventListener('cart-drawer:handle-hw-card-if-product-removed-in-checkout', (event) => {
  const connectedProductsWithCards = event.target.querySelectorAll('cart-drawer [data-hw-group-id]');
  const groups = {};
  connectedProductsWithCards.forEach(el => {
    const id = el.getAttribute('data-hw-group-id');
    if (!groups[id]) groups[id] = [];
    groups[id].push(el);
  });

  // Find groups with only one remaining element and remove the product
  Object.values(groups).forEach(group => {
    if (group.length === 1) {
      const single = group[0];
      const removeBtn = single.querySelector('.line-item__remove-button');
      if (removeBtn) removeBtn.click();
    }
  });
});

document.addEventListener("cart-drawer:remove-connected-product", (event) => {
  if (!event || !event.detail) return;
  const productToRemove = document.querySelector(`[data-hw-group-id="${event.detail.lineItemHwGroupId}"]`);
  if (productToRemove) {
    productToRemove.querySelector('.line-item__remove-button').click();
  }
});

class MainCart extends HTMLElement {
  #controller = new AbortController();

  constructor() {
    super();
    this.signal = this.#controller.signal;
  }

  connectedCallback() {
    const hwGroupIdToRemove = sessionStorage.getItem('hw_group_id_to_remove');
    if (hwGroupIdToRemove) {
      const productToRemove = this.querySelector(`[data-hw-group-id="${hwGroupIdToRemove}"]`);
      if (productToRemove) {
        productToRemove.querySelector('.remove-line-item').click();
      } else {
        sessionStorage.removeItem('hw_group_id_to_remove');
      }
    }
    
    document.addEventListener('main-cart:remove-connected-product', (event) => {
      const productToRemove = this.querySelector(`[data-hw-group-id="${event.detail.lineItemHwGroupId}"]`);
      if (productToRemove) {
        sessionStorage.setItem('hw_group_id_to_remove', event.detail.lineItemHwGroupId);
      }
    }, { signal: this.signal });
  }

  disconnectedCallback() {
    this.#controller.abort();
  }
}

if (!customElements.get('main-cart')) {
  customElements.define('main-cart', MainCart);
}

